_ = require('lodash')

GoalSettingsService = ($http, $q) ->
  ratioToPercent = (data) ->
    _.merge {}, data,
      rat_fairway_center:
        if data.rat_fairway_center then data.rat_fairway_center * 100
      rat_par_on:
        if data.rat_par_on then data.rat_par_on * 100
      rat_bogey_on:
        if data.rat_bogey_on then data.rat_bogey_on * 100

  percentToRatio = (data) ->
    _.merge {}, data,
      rat_fairway_center:
        if data.rat_fairway_center then data.rat_fairway_center / 100
      rat_par_on:
        if data.rat_par_on then data.rat_par_on / 100
      rat_bogey_on:
        if data.rat_bogey_on then data.rat_bogey_on / 100

  calculateDefaultGoal = (my_data) ->
    avg_total_shot:
      if my_data.avg_total_shot then Math.round(my_data.avg_total_shot - 5)
    avg_putt:
      if my_data.avg_putt then my_data.avg_putt - 0.5
    rat_fairway_center: do ->
      return unless my_data.rat_fairway_center
      return 100 if my_data.rat_fairway_center + 10 > 100
      my_data.rat_fairway_center + 10
    rat_par_on: do ->
      return unless my_data.rat_par_on
      return 100 if my_data.rat_par_on + 10 > 100
      my_data.rat_par_on + 10
    rat_bogey_on: do ->
      return unless my_data.rat_bogey_on
      return 100 if my_data.rat_bogey_on + 5 > 100
      my_data.rat_bogey_on + 5

  convertToGoalSettings = (settings) ->
    all_users_data = ratioToPercent(settings.all_users_data)
    my_data = ratioToPercent(settings.my_data)
    goal = ratioToPercent(settings.goal)

    default_goal = calculateDefaultGoal(my_data)
    goal = _.mapValues goal, (v, k) ->
      return Math.round(v * 100) / 100 if _.isNumber v
      if _.isNumber(default_goal[k]) then Math.round(default_goal[k] * 100) / 100

    goal: goal
    my_data: my_data
    all_users_data: all_users_data

  get: ->
    delay = $q.defer()
    promises =
      all_users_data: $http.get('/api/score_cards/all/analysis.json')
      my_data: $http.get('/api/users/me/score_cards/analysis.json')
      goal: $http.get('/api/settings/goal.json')
    $q.all(promises).then (data) ->
      delay.resolve convertToGoalSettings(_.mapValues data, 'data')
    delay.promise

  save: (data) ->
    $http.put('/api/settings/goal.json', percentToRatio(data))

GoalSettingsService.$inject = [
  '$http'
  '$q'
]

module.exports = GoalSettingsService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/goal-settings/goal-settings-service.coffee